import ProductLocationDetails from './ProductLocationDetails'
export default ProductLocationDetails
